const CANADA_PROVINCES = [
    { province: "Alberta", value: "AB" },
    { province: "British Columbia", value: "BC" },
    { province: "Manitoba", value: "MB" },
    { province: "New Brunswick", value: "NB" },
    { province: "Newfoundland and Labrador", value: "NL" },
    { province: "Nova Scotia", value: "NS" },
    { province: "Ontario", value: "ON" },
    { province: "Prince Edward Island", value: "PE" },
    { province: "Quebec", value: "QC" },
    { province: "Saskatchewan", value: "SK" }
]

export default CANADA_PROVINCES;